export default {
    'OPERACION_USUADEPE': (state, mutation) => {
        state.usuaDepe = mutation.usuaDepe
    }
}